module.exports = __webpack_public_path__ + "9bbfc70a963e6860cda0ad3462583aa6.svg";